module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/airdrop2.jpg";